var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", [_vm._v("Ordenes de Compra")])],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "asignacionNoSeriado" },
        [
          _c(
            "v-card",
            [
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex xs12 sm6 md3" },
                    [
                      _c("DatePicker", {
                        attrs: {
                          locale: "es-cl",
                          color: "primary",
                          label: "Inicio Período de Fecha Emisión",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtro_inicio_fecha_alta,
                          callback: function($$v) {
                            _vm.filtro_inicio_fecha_alta = $$v
                          },
                          expression: "filtro_inicio_fecha_alta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs12 sm6 md3" },
                    [
                      _c("DatePicker", {
                        attrs: {
                          locale: "es-cl",
                          color: "primary",
                          label: "Fin Período de Fecha Emisión",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtro_fin_fecha_alta,
                          callback: function($$v) {
                            _vm.filtro_fin_fecha_alta = $$v
                          },
                          expression: "filtro_fin_fecha_alta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs12 sm6 md3" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Estado",
                          "item-text": "configvalor",
                          "item-value": "configid",
                          items: _vm.filter_data.ESTADOS,
                          clearable: "",
                          "prepend-icon": "home_repair_service"
                        },
                        model: {
                          value: _vm.filtro_estado,
                          callback: function($$v) {
                            _vm.filtro_estado = $$v
                          },
                          expression: "filtro_estado"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex xs6 sm3 md3" }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.applyfilters } },
                          [_c("v-icon", [_vm._v("search")]), _vm._v("Filtrar")],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex xs12 sm6 md3" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Razón Social Proveedor",
                          "item-text": "proveedorrazon",
                          "item-value": "proveedorrut",
                          items: _vm.filter_data.PROVEEDOR,
                          "prepend-icon": "home_repair_service",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtro_proveedor,
                          callback: function($$v) {
                            _vm.filtro_proveedor = $$v
                          },
                          expression: "filtro_proveedor"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs12 sm6 md3" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Cuenta Costo",
                          "item-text": "comprarut_contable",
                          "item-value": "comprarut_contable",
                          items: _vm.filter_data.RUT_CONTABLE,
                          "prepend-icon": "home_repair_service",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtro_rut_contable,
                          callback: function($$v) {
                            _vm.filtro_rut_contable = $$v
                          },
                          expression: "filtro_rut_contable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs12 sm6 md3" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Tipo de Equipo",
                          "item-text": "tipoeqname",
                          "item-value": "tipoeqid",
                          items: _vm.filter_data.EQUIPOS,
                          clearable: "",
                          "prepend-icon": "home_repair_service"
                        },
                        model: {
                          value: _vm.filtro_equipo,
                          callback: function($$v) {
                            _vm.filtro_equipo = $$v
                          },
                          expression: "filtro_equipo"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex xs6 sm3 md3" }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.cleanfilters } },
                          [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar")],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c("div", {
                    staticClass: "flex xs12 sm6 md6",
                    attrs: { align: "lef" }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "flex xs12 sm6 md6",
                      attrs: { align: "right" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: { click: _vm.btn_exportar }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n            "),
                          _c(
                            "span",
                            {
                              staticClass: "importExportBtnTexto",
                              staticStyle: { "margin-right": "30px" }
                            },
                            [_vm._v("Exportar csv")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-crear v-btn theme--light",
                          on: { click: _vm.handlerbuttonmodal }
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass:
                                "v-icon v-icon--left material-icons theme--dark",
                              staticStyle: { color: "black" },
                              attrs: { "aria-hidden": "true" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", [_vm._v("Crear")])
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "gridcard rounded-card" },
                [
                  _c("MantenedorGridSinCodigo", {
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      funcionalidadId: _vm.funcionalidad
                    }
                  })
                ],
                1
              ),
              _vm.ModalState
                ? _c("modalCrearOC", {
                    attrs: {
                      show: _vm.ModalState,
                      id_orden_compra: _vm.oc_seleccionada,
                      editable: _vm.editable,
                      editableEq: _vm.editableEq
                    },
                    on: {
                      modalOrdenCompraEmit: function($event) {
                        return _vm.modalOCCallback($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm.CargaArchivoModalState
                ? _c("modalCargarArchivo", {
                    attrs: {
                      show: _vm.CargaArchivoModalState,
                      tieneCostos: _vm.tieneCostos,
                      id_orden_compra: _vm.oc_seleccionada,
                      cantidad_esperada: _vm.cantidad_esperada,
                      oc_flete: _vm.oc_flete,
                      tipoProveedorSelected: _vm.tipoProveedor
                    },
                    on: {
                      modalOrdenCompraEmit: function($event) {
                        return _vm.modalCargarArchivoCallback($event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "titleEvidencia" }, [
                        _c("h2", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("Reporte Solicitado")
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _c("modalAutorizadores", {
        ref: "modalAutorizadores",
        staticClass: "modalAutorizadores",
        attrs: {
          showAutorizadores: _vm.showAutorizadores,
          edicion: _vm.edicionAutorizadores,
          compranumero: _vm.compranumero
        },
        on: {
          cerrarAutorizadores: function($event) {
            return _vm.closeModal()
          },
          autorizadoresConfirmados: function($event) {
            return _vm.requestAutorization($event)
          },
          confirmAutorizadoresEdit: function($event) {
            return _vm.editAutorizadores($event)
          }
        }
      }),
      _vm.modalEstadoSeries
        ? _c("ModalVerEstadoSeries", {
            attrs: { compranumero: _vm.compranumero },
            on: {
              modalAsociacionEmit: function($event) {
                _vm.modalEstadoSeries = $event
              }
            }
          })
        : _vm._e(),
      _vm.ModalVerCostos
        ? _c("ModalVerCostos", {
            attrs: { compranumero: _vm.compranumero },
            on: { modalAsociacionEmit: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleRutaModal", {
            attrs: { compranumero: _vm.compranumero },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }